<div class="container-fluid">

    <div class="pb-0 d-flex flex-wrap">
        <div class="py-2 d-flex flex-row">
            <div *ngIf="scoutPathIndex > 0" class="mt-2 mr-1 p-1">
                <a href="javascript:false;" role="button" (click)="nextPath(-1)"><i class="fa fa-chevron-left"></i></a>
            </div>
            <app-scout-header [scoutTaskDoc]="scoutTaskDoc" [scoutPath]="scoutPath"></app-scout-header>
            <div *ngIf="scoutPathIndex + 1 < scoutPaths?.length" class="mt-2 p-1">
                <a href="javascript:false;" role="button" (click)="nextPath(1)"><i class="fa fa-chevron-right"></i></a>
            </div>
        </div>


        <div class="ml-auto row" style="display:flex;justify-content:center;align-items:center;">
            <div class="col px-1" [ngClass]="statusLocked?'disabled':''">
                <select id="status-select" class="status-label" [ngClass]="scoutPath?.statusId|taskStatusBorderedCss" *ngIf="scoutPath" [(ngModel)]="scoutPath.statusId" (ngModelChange)="onStatusChange($event)">
                    <option [hidden]="true" class="not-started" [ngValue]="1">Not Started</option>
                    <option class="in-progress" [ngValue]="2">In Progress</option>
                    <option class="field-complete" [ngValue]="4">Field Complete</option>
                    <option [hidden]="!this.roleMgr.canEditUsers" class="review-complete" [ngValue]="5">Review Complete</option>
                    <option [hidden]="!this.roleMgr.canEditUsers" class="approved" [ngValue]="3">Approved</option>
                    <option [hidden]="!this.roleMgr.canEditUsers" class="not-using" [ngValue]="6">Not Using</option>
                </select>
            </div>

            <div *ngIf="!uiLocked; else lockedBlock" class="col-auto">
                <div>
                    <i class="fas fa-unlock fa-2x"></i>
                </div>
            </div>
            <ng-template #lockedBlock>
                <div class="col-auto">
                    <div>
                        <i class="fas fa-lock fa-2x"></i>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    

    <div class="alert alert-warning" *ngIf="errorMsg">{{errorMsg}}</div>
    <div class="d-flex flex-wrap">
        
        <div class="flex-xl-grow-1 px-0 pb-4" style="width: 300px; max-width: 450px;">

            <div class="d-flex flex-row justify-content-between">
                <div class="font-italic h5 p-0 m-0 text-nowrap">
                    Path Overall Info
                    <div class="btn-group p-0 m-0" dropdown>
                        <a id="edit-options-btn" href="javascript:false;" behavior="button" dropdownToggle 
                            class="dropdown-toggle" aria-controls="dropdown-edit-options">
                            <span class="caret"></span>
                        </a>
                        <ul style="z-index:9999;min-width:3rem;" id="dropdown-edit-options" *dropdownMenu 
                        class="text-nowrap p-2 dropdown-menu" role="menu" aria-labelledby="edit-options-btn">
                            <li role="menuitem" style="margin-bottom:2px;">
                                <button class="btn btn-primary w-100 text-left" style="border-radius:0;"
                                        (click)="onReportDoc($event)">
                                    <i class="fa fa-file-word mr-1"></i>
                                    Report Builder (MS Word)
                                </button>
                            </li>
                            <li role="menuitem" style="margin-bottom:2px;">
                                <button class="btn btn-primary w-100 text-left" style="border-radius:0;"
                                        (click)="onReportData($event)">
                                    <i class="fa fa-database mr-1"></i>
                                    Report Data
                                </button>
                            </li>
                            <li role="menuitem">
                                <button class="btn btn-secondary w-100 text-left" style="border-radius:0;"
                                        (click)="onShowKml($event)">
                                    <i class="fa fa-globe mr-1"></i>
                                    KML
                                </button>
                            </li>
                        </ul>                        
                    </div>
                    <div *ngIf="isEditing" class="d-flex flex-row small">
                        <button [disabled]="!bPathOrFloorModified||scoutPathForm.invalid" class="text-nowrap m-sm-1 p-sm-1 btn btn-sm btn-secondary" 
                            (click)="onSave()"><i class="fa fa-save"></i>&nbsp;Save
                        </button>
                        <button class="m-sm-1 p-sm-1 btn btn-sm btn-secondary" (click)="onCancel()">&nbsp;Cancel</button>
                    </div>
                </div>
            </div>                
        
            <form #scoutPathForm="ngForm" class="m-0 p-0" style="font-size:14px;" [ngClass]="uiLocked?'disabled':''">
                <div class="py-2">
                    <table class="table table-striped d-inline">
                        <tr>
                            <th class="text-right">Path #</th>
                            <td *ngIf="scoutPath&&!isEditing" role="button" (click)="isEditing=true">
                                {{scoutPath.pathNumber}}
                            </td>
                            <td *ngIf="scoutPath&&isEditing">
                                <input type="number" #pathNumberInput="ngModel" name="pathNumberInput" [(ngModel)]="pathNumberEditValue" 
                                    (keyup)="updateModifiedFlag()" [min]="1" [uniquePathNumber]="[scoutPath,scoutPaths]"
                                    [ngClass]="{ 'invalid-input':  pathNumberInput.invalid && pathNumberInput.dirty}"> 
                                    <div *ngIf="pathNumberInput.dirty && pathNumberInput.errors?.pathNumberExists as error"
                                        class="text-danger font-italic small">
                                        Path #{{error}} already exists.
                                    </div>  
                            </td>
                        </tr>
                        <tr>
                            <th class="text-right">Combined ID</th>
                            <td *ngIf="scoutPath?.pathNumber">{{scoutTaskDoc.buildingId + 'P' + (scoutPath.pathNumber|number:'2.0')}}</td>
                        </tr>
                        <tr><td colspan="2" class="p-sm-1"></td></tr>
                        <tr>
                            <th class="text-right">Building<br>Civic Address</th>
                            <td>{{building?.civicAddress||haPoint?.civicAddress}}</td>
                        </tr>
                        <tr>
                            <th class="text-right">Floor</th>
                            <td *ngIf="scoutPath&&!isEditing" (click)="isEditing=true;" role="button">{{scoutPath.floor}}</td>
                            <td *ngIf="scoutPath&&isEditing">
                                <input name="scoutPathFloor" type='text' class="w-100" (keyup)="updateModifiedFlag()"
                                [(ngModel)]="floorEditValue" #scoutPathFloor="ngModel" number
                                [ngClass]="{ 'invalid-input': scoutPathFloor.invalid && (scoutPathFloor.dirty || scoutPathFloor.touched)}" >
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="p-0"></td>
                        </tr>
                    </table>
                </div>
                <div class="p-0">
                    <app-scout-path-azimuth #scoutPathAzimuth [scoutTaskDoc]="scoutTaskDoc" [scoutPath]="scoutPath"></app-scout-path-azimuth>
                </div>
                <div class="p-0">
                    <table class="table table-striped table-bordered table-sm mb-1 w-100">
                        <tbody>
                        <tr>
                            <th style="border-right:none;text-align: center;" class="w-100">
                                Description
                            </th>
                            <th style="border-left:none;text-align: right;">
                                <button *ngIf="!bIsEditingDescription" (click)="bIsEditingDescription=true;" class="btn btn-secondary btn-small"><i class="fa fa-edit"></i>&nbsp;Edit</button>
                            </th>
                        </tr>
                        <tr>
                            <td colspan=2 *ngIf="bIsEditingDescription; else notEditingDescription">
                                <div class="d-flex flex-fill">
                                    <textarea class="flex-fill" rows=6
                                        placeholder="Enter path description here" 
                                        name="scoutPathDescription" type='text' class="w-100" 
                                        (keyup)="updateDescriptionModifiedFlag()"
                                        [(ngModel)]="descriptionEditValue">
                                    </textarea>
                                </div>
                                <div class="d-flex flex-row justify-content-end p-2">
                                    <button (click)="onSaveDescription()" [disabled]="descriptionEditValue==scoutPath.description" class="btn btn-secondary btn-sm small mr-2">Save</button>
                                    <button (click)="onCancelDescriptionEdit()" class="btn btn-secondary btn-sm small">Cancel</button>
                                </div>
                            </td>
                            <ng-template #notEditingDescription>
                                <td colspan=2>
                                    {{scoutPath?.description}}
                                </td>
                            </ng-template>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="p-0">
                    <app-scout-path-comments *ngIf="scoutPath" #scoutPathComments [scoutTaskDoc]="scoutTaskDoc" [scoutPath]="scoutPath"></app-scout-path-comments>
                </div>
            </form>
        </div>

        <div class="flex-grow-1">
            <div class="d-flex flex-wrap">
                <app-scout-segments-editor #scoutSegmentsEditor [scoutTaskDoc]="scoutTaskDoc" [scoutPathId]="scoutPathId" [locked]="uiLocked"
                    (changed)="segmentsEdited($event)" (pointSelected)="scoutPathPlotter?.setSelectedPoint($event,false)"
                    [buildingPoints]="buildingPoints" [isLoadingBuildingPoints]="isLoadingBuildingPoints" class="p-0 pr-1 pb-1"></app-scout-segments-editor>
                <div class="flex-grow-1">
                    <div class="sticky">
                        <div style="height:600px;min-width:200px;">
                            <app-scout-path-plotter #scoutPathPlotter *ngIf="bTabActive" 
                                [buildingPoints]="buildingPoints"
                                [devices]="devices"
                                [overlay]="scoutPath?.overlay"
                                (pointSelected)="scoutSegmentsEditor?.setSelectedAndScroll($event)"
                                [showRefDataFn]="scoutSegmentsEditor?.onRefClick"
                                [deletePointFn]="scoutSegmentsEditor?.delete"
                                [newPointFn]="scoutSegmentsEditor?.createChild"
                                [locked]="uiLocked"
                                (overlayIntializing)="overlayLoading=$event"
                                class="px-0">
                            </app-scout-path-plotter>
                        </div>
                        <div [ngClass]="uiLocked?'disabled':''">
                            <i *ngIf="overlayLoading" class="fa fa-spin fa-spinner text-muted" style="position:absolute;bottom:15px;right:10px;z-index:10;"></i>
                            <app-scout-path-overlay [scoutTaskDoc]="scoutTaskDoc" [scoutPath]="scoutPath" [overlay]="scoutPath?.overlay"
                                (overlayEdited)="onOverlayEdited($event)">                                
                            </app-scout-path-overlay>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</div>



